import './subtitle.scss'

export const Subtitle = ({
  text,
  style = {},
}: {
  text: string
  style?: React.CSSProperties
}) => {
  return (
    <h2 className="subtitle" style={style}>
      <span>{text}</span>
    </h2>
  )
}
